import React from 'react'
import styles from './Gt2Bands.module.css'

// Closing band. The page used to end on the legal "not included" disclaimer,
// which is the last thing a buyer reads before leaving. This puts the buy-once
// argument there instead and lets the disclaimer sit under it as fine print.
// Static presentational content, no client state, no CTA of its own (the sticky
// SecondaryNavbarAddToCart bar is already on screen).

function Gt2Close() {
  return (
    <section className={styles.wrap} aria-label="One cockpit, years of racing">
      <div className={styles.inner}>
        <div className={styles.close}>
          <span className={styles.closeEyebrow}>Built without compromise</span>
          <h2 className={styles.closeTitle}>One cockpit. Years of racing.</h2>
          <p className={styles.closeText}>
            A direct drive cockpit built to outlast every wheelbase you bolt to it. Build it once,
            and keep it through every pedal set and every season that follows. Designed and
            manufactured in the European Union, backed by a 3 year warranty on VRS manufactured
            components.
          </p>
        </div>
      </div>
    </section>
  )
}

export default Gt2Close
